/**
 * Dashboard Stats Hook
 * React Query hook for fetching dashboard statistics
 */

import { useQuery } from '@tanstack/react-query';
import { dashboardAPI } from '../services/api';

/**
 * Hook to fetch dashboard statistics
 * Auto-refreshes every 30 seconds
 */
export const useDashboardStats = () => {
  return useQuery({
    queryKey: ['dashboard', 'stats'],
    queryFn: () => dashboardAPI.getStats(),
    staleTime: 30 * 1000, // 30 seconds
    refetchInterval: 60 * 1000 // Refresh every minute
  });
};
